const handleDeleteFrequencyFailFormParamFreq = {
  title: 'PERIODICIDADE NÃO PODE SER DELETADO'
};

export default handleDeleteFrequencyFailFormParamFreq;
